import {useUserContext} from '@/components/Providers/UserContext.tsx';
import MenuIcon from '@mui/icons-material/Menu';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import * as React from 'react';

const Hamburger = (): React.ReactElement => {
    const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
    const {logOut} = useUserContext();

    const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    return (
        <Box sx={{flexGrow: 1}}>
            <IconButton
                size='large'
                aria-label='account of current user'
                aria-controls='menu-appbar'
                aria-haspopup='true'
                onClick={handleOpenNavMenu}
                color='inherit'
            >
                <MenuIcon sx={{color: '#000'}} />
            </IconButton>
            <Menu
                id='menu-appbar'
                anchorEl={anchorElNav}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
            >
                <MenuItem onClick={handleCloseNavMenu}>
                    <Typography textAlign='center'>My Rentals</Typography>
                </MenuItem>
                <MenuItem onClick={logOut}>
                    <Typography textAlign='center'>Sign-Out</Typography>
                </MenuItem>
            </Menu>
        </Box>
    );
};

export default Hamburger;
